import { render, staticRenderFns } from "./NotSablonList.vue?vue&type=template&id=d9326d2a"
import script from "./NotSablonList.vue?vue&type=script&lang=ts"
export * from "./NotSablonList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports